<app-header></app-header>
<div class="wrapper">
  <div class="container" >
    <div class="row justify-content-center">
      <div class="col-12 col-sm-12 col-md-12">
        <div class="partner-profile-detail gray-bg" *ngIf="data?.partnar_info">
          <div class="partner-profile">
            <div class="ratio-slider ratio-1-1">
              <img *ngIf="data?.partnar_info?.image" [src]="[data.partnar_info.image]" />
              <img *ngIf="!data?.partnar_info?.image" [src]="[appConstant.userNoImage]" />
            </div>
          </div>
          <div class="user-detail">
            <h1>{{ data?.partnar_info?.name }}</h1>
            <p class="text-secondary" *ngIf="data?.partnar_info?.total_content">
              {{ "GRID.TOTAL_CONTENT" | translate }} <span class="dots"></span>
              {{ data?.partnar_info?.total_content }}
            </p>
            <p class="text-secondary" *ngIf="data?.partnar_info?.created_at">
              Registered At
              {{ data?.partnar_info?.created_at | date: appConstant.dobFormat }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <app-grid-simmer *ngIf="simmerStatus"></app-grid-simmer>
    <div class="home-page multi-slider-section" *ngIf="!simmerStatus">
      <div *ngIf="partnerData?.length > 0">
        <section class="multi-slider">
          <div class="" *ngFor="let partner of partnerData; let c = index">
            <div class="">
              <div class="section-head" *ngIf="partner?.content?.length > 0" (mouseenter)="playOff()">
                <a [routerLink]="
                    partner.subcategoryCount > 0
                      ? ['/partner-detail', data?.partnar_info?.id]
                      : ['/list', partner.slug]
                  "
                  [queryParams]="
                    partner.subcategoryCount > 0
                      ? { slug: partner.slug }
                      : { partnar_id: data?.partnar_info?.id }
                  "
                >
                  <h2>{{ partner | languageTranslate }}</h2>
                </a>

                <a *ngIf="partner?.content?.length > 5" href="javascript:void(0)" class="text-primary view-all-link"
                  [routerLink]="
                    partner.subcategoryCount > 0
                      ? ['/partner-detail', data?.partnar_info?.id]
                      : ['/list', partner.slug]
                  "
                  [queryParams]="
                    partner.subcategoryCount > 0
                      ? { slug: partner.slug }
                      : { partnar_id: data?.partnar_info?.id }
                  "
                >
                  {{ "HOME.VIEW_ALL" | translate }}
                </a>
              </div>

              <div class="populer-slider" id="slider-top">
                <owl-carousel-o [options]="watching">
                  <ng-container *ngFor="let data of partner.content; let i = index">
                    <ng-template carouselSlide [id]="data.public_id">
                      <div class="series-box">
                        <app-grid [data]="data" [gridType]="'landscape'"></app-grid>
                      </div>
                    </ng-template>
                  </ng-container>
                </owl-carousel-o>
              </div>
            </div>
          </div>
        </section>
        <!-- <div class="text-center" *ngIf="show === true" (mouseenter)="playOff()">
            <button type="button" class="btn btn-theme" (click)="viewMoreData()">
              View More
            </button>
          </div> -->
      </div>
      <div class="record-not-available" *ngIf="partnerData?.length == 0 && !simmerStatus">
        <div class="text-center">
          <img src="assets/images/no-recoard-playlist.png" />
          <p class="no-recored-content text-secondary">
            {{ "RECORD_NOT_FOUND" | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<app-model-player *ngIf="service.modelData" [data]="service.modelData" [playerStatus]="service.playerReady"
  [position]="service.position"></app-model-player>
<app-footer></app-footer>